<!--
 * @Description: 
 * @Author: knx-xc
 * @LastEditTime: 2020-09-27 14:21:40
 * @LastEditors: knx-xc
--> 
<template>
  <div class="about">
    <PageTitle></PageTitle>
    <Bread :breads="[{name:'关于我们',paht:''}]"></Bread>
    <!-- 企业介绍  animated-->
    <div class="floor-1 container-body  fadeInUp " v-if="aboutCompany.floor1">
      <div class="profile ">
        <div class="profile-image">
          <img :src="aboutCompany.floor1.img" alt="">
        </div>
        <div class="profile-detail">
          <h1 v-text="aboutCompany.floor1.title"></h1>
          <p v-for="el in aboutCompany.floor1.detail" :key="el" v-text="el"></p>
        </div>
      </div>
      <ul class="nav">
        <li v-for="(item,index) of aboutCompany.floor1.nav" :key="index">
          <img :src="item.img" alt="">
          <h1 v-text="item.title"></h1>
          <p v-text="item.subtitle"></p>
        </li>
      </ul>
    </div>
    <div class="floor-2 " v-if="aboutCompany.floor2">
      <div class="floor-head-bg" :style="'background-image:url('+aboutCompany.floor2.imgBg+')'"></div>
      <div class="profile container-body">
        <!-- 医院 -->
        <div class="hospital">
          <div class="floor-title ">
            <img src="../../../assets/images/about/icon-left.png" alt="">
            <h1 v-text="aboutCompany.floor2.title"></h1>
            <img src="../../../assets/images/about/icon-right.png" alt="">
          </div>
          <div class="profile-info">
            <p v-for="el in aboutCompany.floor2.detail" :key="el" v-text="el"> </p>
          </div>
        </div>
        <!-- 优势 -->
        <div class="advantage">
          <div class="floor-title">
            <img src="../../../assets/images/about/icon-left.png" alt="">
            <h1 v-text="aboutCompany.floor2.title2"></h1>
            <img src="../../../assets/images/about/icon-right.png" alt="">
          </div>
          <ul class="nav">
            <li v-for="(item,index) of aboutCompany.floor2.nav" :key="index">
              <div class="img-box" :style="'background-image:url('+item.imgBg+')'">
                <h1 v-for="el of item.title" :key="el" v-text="el"></h1>
              </div>
              <div class="advantage-info">
                <p v-for="el of item.subtitle" :key="el" v-text="el"></p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="floor-3 " v-if="aboutCompany.floor3">
      <div class="floor-title">
        <img src="../../../assets/images/about/icon-left.png" alt="">
        <h1 v-text="aboutCompany.floor3.title"></h1>
        <img src="../../../assets/images/about/icon-right.png" alt="">
      </div>
      <ul class="steep container-body">
        <li v-for="(item,index) of aboutCompany.floor3.steep" :key="index">
          <div class="cricle" :style="'background-color:'+item.bgColor">
            <div>
              <h1 v-text="index+1"></h1>
              <h2 v-text="item.name"> </h2>
            </div>
          </div>
          <div class="tips">
            <p v-for="el in item.setps" :key="el" v-text="el"></p>
          </div>
        </li>
      </ul>

    </div>

  </div>

</template>
 
<script>
import PageTitle from '@/components/user/PageTitle';
import { getAbout } from "../../../request/api.user/all"
export default {
  name: '',
  components: { PageTitle },
  data() {
    return {
      aboutCompany: {
        // 公司简介
        floor1: {
          title: '企业介绍',
          img: require("../../../assets/images/about/company.png"),
          detail: ['重庆康乃馨信息科技有限公司，是一家专业从事“互联网+医疗”及提供远程药学、医学服务和电子处方流转的高新技术企业，致力于为百姓提供专业的医疗和便利服务，主要经营从事计算机信息科技领域内的技术开发，技术咨询服务；计算机软件开发；网站建设；网页设计等。旗下设有互联网远程诊疗；9号云诊智慧药房；无人售药机；自营商城等。', '互联网远程诊疗，平台利用移动互联网技术、音视频编解码技术为用户提供更便捷、更实惠、更实用的药学和医学服务。用户通过电脑、随时联系后台的执业药师和医生，对如何科学用药、小病的自我治疗以及慢性病的科学护理等方面进行视频咨询。由后台专家进行一对一的专业指导，保证用户安全用药，为用户提供“线上+线下、全科+专科”的新型医疗健康服务。', '此外，康乃馨信息科技有限公司与合作药房联合打造了重庆首家带有远程问诊的无人售药机，药品品类高达200余种，完全满足用户夜间购药的需求，与普通售药机不同之处在于，9号云诊的售药机设有单独的问诊室，用户可远程问诊医生后再购药，为市民的用药做到全面的安全保障。'],
          nav: [
            {
              img: require("../../../assets/images/about/floor-1-nav-1.png"),
              title: '严谨专业',
              subtitle: '产品的每一个细节，都经过深入场景的打磨和验证',
            },
            {
              img: require("../../../assets/images/about/floor-1-nav-2.png"),
              title: '智能创新',
              subtitle: '不断创新，用更智能的技术，提升服务和管理环节的效率',
            },
            {
              img: require("../../../assets/images/about/floor-1-nav-3.png"),
              title: '安全稳定',
              subtitle: '不断突破，建立更高等级的安全系统和更强性能的运行环境',
            },
            {
              img: require("../../../assets/images/about/floor-1-nav-4.png"),
              title: '灵活简单',
              subtitle: '关注客户，提供轻松获取的个性化解决方案和专人全程服务',
            }
          ],
        },
        //合作医院
        floor2: {
          title: '合作医院',
          imgBg: require("../../../assets/images/about/floor-2-bg.png"),
          // detail: ['重庆京西医院始建于2003年，医院集医疗、康复、保健、教研、预防、托老于一体的现代化综合医院，是重庆市城镇职工医疗保险、职工生育保险、工商医疗保险、城乡医疗保险定点医疗机构。经过十多年的发展和技术沉淀，现已建设成具有国家二级医院规模和技术水平的综合性医院。', '作为一个致力于为人类健康服务的医疗机构，重庆京西医院认为，医学从业者必须具备高尚的医德和精湛的医术，因此医院积极提升医疗品质服务，接轨国际先进医疗，通过远程会诊的方式帮助中国患者实现全球诊疗，不出国门即可获取国际专家的诊疗意见。'],
          detail: ['桃子互联网医院成立于2016年，是一家互联网医疗企业，公司规模110余人。截止目前，共获得软件著作权100+  项，国家级专利1项，取得第二类医疗器械经营许可、增值电信业务经营许可证以及互联网药品信息服务证书等。 于2018年12月，获得成都市颁发的首块互联网医院牌照，基于实体医院开展互联网远程医疗服务。', '公司以互联网技术为驱动，持续建设连接全社会医疗资源的开放型医联体平台。并不断整合上游优质医疗资源， 陆续推出互联网分级诊疗平台、云门诊、远程影像诊断、全科辅助诊断、远程心电诊断、远程病理诊断、云药库 等业务。同时，正在与全市场相关的医疗机构进行新模式的探索，还将提供医疗金融，医疗保险、药品耗材等更 多的服务模式。'],
          title2: '我们的优势',
          nav: [
            {
              imgBg: require("../../../assets/images/about/floor-2-nav-1.png"),
              title: ['专业技术团队'],
              subtitle: [
                '项目产品及开发人员大多为医药相关工作经验；', '产品的每一个细节，都经过深入场景的打磨和验证产品更具专业性。'
              ]
            },
            {
              imgBg: require("../../../assets/images/about/floor-2-nav-2.png"),
              title: ['专职医生', '药师团队'],
              subtitle: ['专职医生和药师团队，', '更能保证用户快捷及时的便民服务。']
            },
            {
              imgBg: require("../../../assets/images/about/floor-2-nav-3.png"),
              title: ['线上线下', '模拟场景', '自主研发'],
              subtitle: ['实体门店为远程诊疗项目研发对象，更切实开发；', '药店场景的“医药分家+分级诊疗”的互联网医疗新模式。', '项目产品及开发人员大多为医药相关工作经验；',
              ]
            },
            {
              imgBg: require("../../../assets/images/about/floor-2-nav-4.png"),
              title: ['售后服务'],
              subtitle: ['一对一进行专业实践操作培训，系统免费进行维护升级；', '如出现意外故障，我们将在12小时内准时，免费上门查看维护；', '服务不满意，投诉有奖。']
            },
          ],

        },
        floor3: {
          title: "如何入驻",
          //入驻步骤
          steep: [
            {
              name: '合同签约',
              bgColor: '#E88015',
              setps: ['确认合同协议', '查看合同内容须知', '双方签订协议', '盖公司鲜章']
            },
            {
              name: '商家缴费',
              bgColor: '#E8BE15',
              setps: ['商家对公账号打款缴费', '商家确认缴费无误', '企业确认收款信息']
            },
            {
              name: '系统安装',
              bgColor: '#2BCBB0',
              setps: ['建立门店信息档案', '门店商品库存对接', '工作人员上门安装', '商家登录门店端使用']
            },
            {
              name: '系统培训',
              bgColor: '#29B3CF',
              setps: ['实践操作培训', '一对一专人培训']
            },
            {
              name: '售后服务保障',
              bgColor: '#1C84D4',
              setps: ['商家信息回访', '问题意见反馈']
            },
          ]
        },
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
}
</script>
 
<style  lang="less" rel="stylesheet/less"  scoped>
.about {
  // background: #ffffff;
  .floor-title {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 26px;
      height: 26px;
    }
    h1 {
      font-size: 40px;
      color: #333333;
      font-weight: bold;
      margin: 0 20px;
    }
  }
  .floor-1 {
    // background: #ffffff;
    .profile {
      // margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      position: relative;
      .profile-image {
        // width: 824px;
        width: 554px;
        height: 412px;
        position: relative;
        z-index: 1;
        // position: absolute;
        // left: 0;
        // top: 0px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .profile-detail {
        flex: 1;
        margin-left: -100px;
        padding: 30px 25px;
        // position: absolute;
        // left: 40%;
        // top: 0px;
         position: relative;
        z-index: 2;
        background: #ffffff;
        box-shadow: 0px 3px 6px rgba(230, 230, 230, 0.5);
        text-align: left;
        text-overflow: ellipsis;
        overflow: hidden;
        h1 {
          font-size: 40px;
          font-weight: bold;
          line-height: 52px;
        }
        p {
          margin-top: 30px;
          font-size: 16px;
          line-height: 26px;
          color: #333333;
        }
      }
    }
    .nav {
      position: relative;
      padding: 100px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      li {
        // width: 260px;
        flex: 1;
        padding: 0 20px;
        img {
          width: 120px;
          height: 120px;
        }
        h1 {
          margin-top: 20px;
          font-size: 20px;
          font-weight: bold;
        }
        p {
          margin-top: 25px;
          font-size: 16px;
          color: #333333;
          line-height: 40px;
          font-weight: bold;
        }
      }
      li:nth-child(2n) h1 {
        color: #1c84d4;
      }
      li:nth-child(2n + 1) h1 {
        color: #e88015;
      }
    }
  }
  .floor-2 {
    padding-bottom: 80px;
    .floor-head-bg {
      height: 447px;
      background-image: url("../../../assets/images/about/floor-2-bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center center;
    }

    /* 简介*/
    .profile {
      // padding: 0 200px;

      /* 医院 */
      .hospital {
        // margin: 0 100px;
        padding: 64px 30px;
        background: #ffffff;
        box-shadow: 0px 10px 20px rgba(230, 230, 230, 0.5);
        // transform: translateY(-253px);
        margin-top: -253px;

        .profile-info {
          margin-top: 80px;

          p {
            font-size: 16px;
            color: #333333;
            line-height: 32px;
            text-align: left;
            padding-bottom: 20px;
          }
        }
      }
      /* 优势 */
      .advantage {
        margin-top: 80px;
        .nav {
          margin-top: 60px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          li {
            flex: 1;
            box-shadow: 0px 6px 12px rgba(230, 230, 230, 0.5);
            align-self: stretch;
            background: #ffffff;
            .img-box {
              width: 100%;
              height: 208px;
              background-repeat: no-repeat;
              background-size: 100% 100%;
              background-position: center center;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              h1 {
                font-size: 40px;
                line-height: 52px;
                color: #ffffff;
              }
            }
            .advantage-info {
              padding: 30px 14px;
              p {
                color: #333333;
                font-size: 18px;
                line-height: 30px;
                text-align: left;
              }
            }
          }
          li:not(:first-child) {
            margin-left: 11px;
          }
        }
      }
    }
  }
  .floor-3 {
    height: 690px;
    background-image: url("../../../assets/images/about/floor-3-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    padding-top: 80px;
    color: #ffffff;
    .floor-title h1 {
      color: #ffffff;
    }
    ul.steep {
      margin-top: 80px;
      // padding: 0 200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      li {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        align-self: stretch;
        .cricle {
          width: 204px;
          height: 204px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          h1 {
            font-size: 60px;
            font-weight: bold;
            line-height: 79px;
          }
          h2 {
            font-size: 20px;
            font-weight: bold;
            line-height: 26px;
          }
        }
        .tips {
          margin-top: 50px;
          p {
            font-size: 16px;
            line-height: 32px;
          }
        }
      }
    }
  }
}
</style>